import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXConfirmModal from "../../../../Components/Modals/BMXConfirmModal/BMXConfirmModal";
import ConfirmInvoiceModalForm from "../../ConfirmModalsForms/ConfirmInvoiceModalForm/ConfirmInvoiceModalForm";
import { useState } from "react";

const ConfirmInvoiceModal = (props) => {
  const { handleHide, show, confirmButtonName, initialValues } = props;
  const formName = "ConfirmInvoiceModal";
  const { t } = useTranslation();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomFaVatNumber, setCustomFaVatNumber] = useState(false);

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="submit"
          type="subbmit"
          buttontype="Button"
          bmxclass="secondary background"
          form={formName}
        >
          {confirmButtonName ? t(`${confirmButtonName}`) : t("global:yes")}
        </BMXButton>
        {!isCustomFaVatNumber ?
          <BMXButton
            data-cy="button"
            type="button"
            buttontype="Button"
            bmxclass="secondary background"
            onClick={() => setCustomFaVatNumber(true)}
          >
            {t("global:confirmInvoiceModal.customFaVatNumber")}
          </BMXButton>
          : null}
      </>
    );
  };

  const downloadButtons = () => {
    return (
      <>
        {Boolean(initialValues?.invoiceNumber) && Boolean(initialValues?.optimaDocumentId) ?
          <BMXButton
            data-cy="submit"
            type="subbmit"
            buttontype="Button"
            bmxclass="secondary background "
            form={formName}
            disabled={isLoading}
          >
            {t(`global:download`)}
          </BMXButton> : null}
      </>
    );
  };

  return (
    <BMXConfirmModal
      open={show}
      width={"500px"}
      height={"250px"}
      onClose={handleHide}
      buttons={Boolean(initialValues?.invoiceNumber) || Boolean(isError) || Boolean(isLoading) ? (Boolean(initialValues?.invoiceNumber) ? downloadButtons() : null) : buttons()}
      cancel={Boolean(initialValues?.invoiceNumber) || Boolean(isError) || Boolean(isLoading) ? "global:exit" : "global:reckoning.no"}
    >
      <ConfirmInvoiceModalForm
        {...props}
        isError={isError}
        setIsError={setIsError}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        formName={formName}
        handleHide={handleHide}
        isCustomFaVatNumber={isCustomFaVatNumber}
      />
    </BMXConfirmModal>
  );
};

export default connectModal({ name: "ConfirmInvoiceModal" })(
  ConfirmInvoiceModal
);
